import {
    many,
    attr,
    fk,
    oneToOne,
} from 'redux-orm';
import { OBJECT_TYPE_ROUND_TABLE } from '%paysera_seat_selection/js/seatSelection/config/constants';
import singleLabel from '../defaults/singleLabel';
import polygon from '../defaults/polygon';
import BaseModel from './BaseModel';

class RoundTable extends BaseModel {
    static modelName = 'RoundTable';

    static fields = {
        ...BaseModel.fields,
        compiled: attr({
            getDefault: () => ({
                polygon,
                size: attr(),
                fill: attr(),
                stroke: attr(),
                strokeWidth: attr(),
            }),
        }),
        label: attr({ getDefault: () => singleLabel }),
        configuration: oneToOne('Configuration'),
        seats: many('Seat'),
        hall: fk('Hall'),
        objectType: attr({ getDefault: () => OBJECT_TYPE_ROUND_TABLE }),
        gaps: attr({ getDefault: () => 0 }),
        autoScale: attr({ getDefault: () => false }),
    };
}

export default RoundTable;
